import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatLegacyRippleModule as MatRippleModule } from '@angular/material/legacy-core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

import { LayoutComponent } from './layout.component';
import { LayoutDesktopComponent } from './desktop/desktop.component';
import { LayoutSidebarComponent } from './sidebar/sidebar.component';
import { LayoutResponsiveComponent } from './responsive/layout-responsive.component';
import { HeaderComponent } from './responsive/header/header.component';
import { FooterComponent } from './responsive/footer/footer.component';
import { MobileLayoutComponent } from './mobile/mobile-layout/mobile-layout.component';
import { MenuService } from './services/menu-service';
import {
  SAJIconAccountBoundedComponent,
  SAJIconAddPersonComponent,
  SAJIconCalendarComponent,
  SAJIconCheckComponent,
  SAJIconChevronRightComponent,
  SAJIconDocumentsComponent,
  SAJIconEveningComponent,
  SAJIconEyeComponent,
  SAJIconGearComponent,
  SAJIconHomeComponent,
  SAJIconOverflowComponent,
  SAJIconQuestionBoundedComponent,
  SAJIconShareComponent,
  SAJIconSortComponent,
  SAJIconStarComponent,
  SAJIconThumbsUpComponent,
  SAJIconWebComponent,
} from '@snagajob/icons';
import { SidebarNavigationComponent } from './sidebar-navigation/sidebar-navigation.component';
import { SAJAccordionModule } from '@snagajob/accordion';
import { AccountInfoComponent } from './account-info/account-info.component';
import { SAJAvatarModule } from '@snagajob/avatar';
import { SAJMenuModule } from '@snagajob/menu';
import { SAJButtonModule } from '@snagajob/button';
import { SAJBrandModule } from '@snagajob/logo';
import { AvatarNamePipe } from './account-info/avatar-name.pipe';
import { SAJTooltipModule } from '@snagajob/tooltip';
import { SAJTruncatePipeModule } from '@snagajob/angular/pipes/truncate';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatMenuModule,
    MatButtonModule,
    MatRippleModule,
    MatIconModule,
    MatSidenavModule,
    MatExpansionModule,
    MatDividerModule,
    MatDialogModule,
    SAJBrandModule,
    SAJButtonModule,
    SAJMenuModule,
    SAJAvatarModule,
    SAJAccordionModule,
    SAJIconAccountBoundedComponent,
    SAJIconChevronRightComponent,
    SAJIconGearComponent,
    SAJIconQuestionBoundedComponent,
    SAJIconHomeComponent,
    SAJIconEyeComponent,
    SAJIconDocumentsComponent,
    SAJIconThumbsUpComponent,
    SAJIconStarComponent,
    SAJIconAddPersonComponent,
    SAJIconWebComponent,
    SAJIconCalendarComponent,
    SAJIconOverflowComponent,
    SAJIconAccountBoundedComponent,
    SAJIconGearComponent,
    SAJIconSortComponent,
    SAJIconQuestionBoundedComponent,
    SAJIconEveningComponent,
    SAJIconCheckComponent,
    SAJTooltipModule,
    SAJTruncatePipeModule,
    SAJIconShareComponent,
  ],
  declarations: [
    LayoutDesktopComponent,
    MobileLayoutComponent,
    LayoutSidebarComponent,
    LayoutResponsiveComponent,
    LayoutComponent,
    HeaderComponent,
    FooterComponent,
    SidebarNavigationComponent,
    AccountInfoComponent,
    AvatarNamePipe,
  ],
  exports: [
    LayoutComponent,
    LayoutDesktopComponent,
    MobileLayoutComponent,
    LayoutResponsiveComponent,
    LayoutSidebarComponent,
  ],
  providers: [MenuService],
})
export class SnagLayoutModule {}
